import CarouselItem from 'element-ui/packages/carousel-item';

export default {
	extends: CarouselItem,
	name: 'CarouselItem'
};
